module.exports = __webpack_public_path__ + "0badc1633f1c0067aac724a85298ef6e.png";